import React from 'react';
import { Card, Badge, ProgressBar } from './ds';
import { getRisk } from '../utils/posture';

const FONT_MONO = "'IBM Plex Mono', ui-monospace, 'SF Mono', Menlo, monospace";

// Kategorie-Kachel für den DIN-SPEC-27076-Breakdown. Geteilt zwischen Dashboard
// und dem anonymen Ergebnis-Screen (AUD-53), damit beide identisch aussehen.
const CategoryCard = ({ name, score, findings }) => {
  const risk = getRisk(score);
  return (
    <Card padding={20}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ fontSize: 13.5, fontWeight: 600, color: '#101623', flex: 1, marginRight: 10, lineHeight: 1.3 }}>
          {name}
        </div>
        <Badge tone={risk.tone}>{risk.label}</Badge>
      </div>
      <div style={{ marginBottom: 12 }}>
        <span style={{ fontFamily: FONT_MONO, fontSize: 28, fontWeight: 600, color: '#101623', letterSpacing: '-0.01em', lineHeight: 1 }}>
          {score}
        </span>
        <span style={{ fontSize: 13, color: '#8A93A3' }}> /100</span>
      </div>
      <ProgressBar value={score} tone={risk.tone === 'secure' ? 'secure' : risk.tone === 'warning' ? 'warning' : 'critical'} style={{ marginBottom: 10 }} />
      <div style={{ fontSize: 12, color: '#8A93A3' }}>
        {findings} offene{findings !== 1 ? ' Befunde' : 'r Befund'}
      </div>
    </Card>
  );
};

export default CategoryCard;
